import { render, staticRenderFns } from "./SendRequestRepliesTab.vue?vue&type=template&id=327d1a24&scoped=true&lang=pug"
import script from "./SendRequestRepliesTab.vue?vue&type=script&lang=ts"
export * from "./SendRequestRepliesTab.vue?vue&type=script&lang=ts"
import style0 from "./SendRequestRepliesTab.vue?vue&type=style&index=0&id=327d1a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327d1a24",
  null
  
)

export default component.exports